import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MapState } from '../../map/reducer';
import { SortDirection } from '../../../../utils';
import { sortGeoAction } from '../../map/actions';

function sortGeoComponent(sort: SortDirection): ReactElement {
  switch (sort) {
    case SortDirection.ASCENDING:
      return <span>N&mdash;S</span>;
    case SortDirection.DESCENDING:
      return <span>S&mdash;N</span>;
    case SortDirection.NONE:
    default:
      return <span>&nbsp;&mdash;&nbsp;</span>;
  }
}

export default function Sorting(): ReactElement {
  const dispatch = useDispatch();
  const { sortGeo } = useSelector((state: { map: MapState }) => ({
    sortGeo: state.map.sortGeo,
  }));
  return (
    <ul
      style={{
        listStyle: 'none',
        display: 'flex',
        flexFlow: 'row',
      }}
    >
      <li>Sortera:&nbsp;</li>
      <li
        style={{ cursor: 'pointer' }}
        onClick={() => {
          dispatch(sortGeoAction());
        }}
      >
        &nbsp;Geo: {sortGeoComponent(sortGeo)}
      </li>
    </ul>
  );
}
